import { CSSProperties } from 'react';

export default function DeliveryIcon({ s }: { s?: CSSProperties }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      style={{ ...s, verticalAlign: 'middle ' }}
    >
      <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_3412_20014)" />
      <path
        d="M19.8485 7.87891C14.4196 7.87891 10 12.3152 10 17.7577C10 18.4849 10.0739 19.1516 10.2093 19.7577C10.517 21.3092 11.2187 22.788 12.2774 24.0729L19.0113 31.7092C19.2452 31.9759 19.59 32.1213 19.947 32.1213C20.3163 32.1213 20.6487 31.9638 20.8826 31.6971L27.4441 24.0365C28.4782 22.788 29.1799 21.3093 29.4754 19.7941C29.6231 19.1517 29.697 18.4849 29.697 17.7577C29.697 12.3152 25.2774 7.87891 19.8485 7.87891ZM19.8485 21.2122C17.8172 21.2122 16.1553 19.5759 16.1553 17.5759C16.1553 15.5758 17.8172 13.9395 19.8485 13.9395C21.8798 13.9395 23.5417 15.5758 23.5417 17.5759C23.5417 19.5759 21.8798 21.2122 19.8485 21.2122Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3412_20014"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6F3DFD" />
          <stop offset="1" stopColor="#1399D6" />
        </linearGradient>
      </defs>
    </svg>
  );
}
